import { Component, OnInit, SimpleChanges, ElementRef, ViewEncapsulation, ViewChildren, QueryList } from '@angular/core';

import { Vraag, Antwoord } from '@models/claims';
import { Meetgegevens, VraagboomMultiResultaat } from '@models/vragenboom';

import { BaseVraagControlDirective } from '../base/base-vraag-control';
import { TekstregelsValidator } from '../../../utils/validation/tekstregels.validator';
import { FormatHelper, ValidatieregelHelper } from '@services/public_api';
import { DataService, MetenMapper } from '@components/public_api';

@Component({
  selector: 'app-tekstregel',
  templateUrl: './tekstregel.component.html',
  styleUrls: ['./tekstregel.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TekstregelComponent extends BaseVraagControlDirective<VraagboomMultiResultaat> implements OnInit {
  @ViewChildren('answer') answers: QueryList<ElementRef>;

  resultaat: VraagboomMultiResultaat = new VraagboomMultiResultaat();
  indexFocus: number = 0;
  errormessageEndPartRequired: string = ' is verplicht';
  prefilledMessage: string;
  optiesGeslacht = ['Man', 'Vrouw', 'Anders'];
  _meetgegevens: Meetgegevens;
  _meetsleutel: string;
  public _dataService: DataService;

  constructor(_dataService: DataService) {
    super(_dataService);
    this._dataService = _dataService;
  }

  ngOnInit() {
    this._meetgegevens = this._dataService.getMeetgegevens();
    this._meetsleutel = this._meetgegevens.sleutel;
    if (this._meetgegevens.status === 'afronden-') {
      this._meetsleutel = this._dataService.getProductOrOmschrijvingLineOfBusiness().toLowerCase() + '-';
    }
  }

  initialize(changes: SimpleChanges): void {
    if (this.antwoordResultaat != null && this.antwoordResultaat.resultaat != null) {
      this.resultaat = this.antwoordResultaat.resultaat;
    } else {
      this.fillFields();
    }

    this.answers.first.nativeElement.focus();
  }

  protected fillFields() { }

  hasFocus(index: number) {
    return index === this.indexFocus && !this.submitClicked;
  }

  isLeeg(index: number): boolean {
    return (!this.vraag.antwoorden[index].waarde || this.vraag.antwoorden[index].waarde.length === 0);
  }

  isRadio(index: number): boolean {
    return this.vraag.antwoorden[index].variabeleWaarde?.toUpperCase().indexOf('GESLACHT') > -1;
  }

  geefOpties(index: number): string[] {
    if (this.vraag.antwoorden[index].variabeleWaarde?.toUpperCase().indexOf('GESLACHT') > -1) {
      return this.optiesGeslacht;
    }
    return [];
  }

  setFocus(index: number, value: boolean): void {
    this.indexFocus = index;
    if (!value) {
      this.vraag.antwoorden[index].hadFocus = true;
    }
  }

  setSubmitClickedFalse() {
    this._dataService.setSubmitClicked(false);
  }

  hasValidValue(index: number) {
    if (!this.vraag || !this.vraag.antwoorden || index < 0) {
      return false;
    }
    if (this.submitClicked) {
      this.vraag.antwoorden[index].hadFocus = true;

      if (this.vraag.antwoorden[index].verplicht !== false && (!this.vraag.antwoorden[index].waarde || this.vraag.antwoorden[index].waarde == '')) {
        return false;
      }
    }
    return TekstregelsValidator.isValidValue(this.vraag.antwoorden[index].waarde, this.vraag.antwoorden[index]);
  }

  formatValue(antwoord: Antwoord) {
    if (antwoord.waarde?.length > 0 && ValidatieregelHelper.get(antwoord.validatieParameters, 'IBAN') != null) {
      antwoord.waarde = antwoord.waarde.toUpperCase();
    }
    if (antwoord.waarde?.length > 0 && ValidatieregelHelper.get(antwoord.validatieParameters, 'KENTEKEN') != null) {
      antwoord.waarde = FormatHelper.formatKenteken(antwoord.waarde);
    }
  }

  notifyAntwoord() {
    const antwoorden: Antwoord[] = [];

    this.vraag.antwoorden.forEach((antwoord: Antwoord) => {
      if (antwoord.waarde) {
        antwoorden.push(antwoord);
      }
      this.resultaat.resultaten.set(antwoord.id, antwoord.waarde);
    });

    this.setAntwoord(antwoorden, this.resultaat);
  }

  validate(vraag: Vraag, antwoorden: Antwoord[], resultaat: VraagboomMultiResultaat): boolean {
    return TekstregelsValidator.isValidTekstregels(vraag, resultaat);
  }

  geefMeetid(vraag: Vraag, optie: string): string {
    return 'ipoclick-radio-' + this._dataService.getMeetidPazaProces() + '-' +
      this._meetgegevens.status + this._meetsleutel +
      MetenMapper.geefVolgnr(this.vraag, this._meetgegevens.reeks) + '_' +
      MetenMapper.formatTitelMetToevoeging(vraag.titel, vraag.titel_toevoeging) + '-' + MetenMapper.format(optie);
  }
}
